module.exports = __webpack_public_path__ + "img/panteleev.b917e941.jpg";